<div class="radioInput w-100 d-flex flex-column" *ngIf="showInput">
  <div>
    <span *ngIf="Required" class="required-asterisk">*</span>
    <label for="" class="mb-2"> {{ name | translate }} </label>
  </div>
  <div class="options-wrapper row">
    <div *ngFor="let option of options" class="col-6 col-md-3">
      <div class="feedback__inner__form__gender__item">
        <label class="d-flex align-items-center gap-2">
          <input
            type="radio"
            [name]="name"
            [value]="option.id"
            [checked]="value == option.id"
            [disabled]="disabled"
            (change)="changeValue(option.id)"
          />
          {{ isEnglish ? option.nameEN : option.name }}
        </label>
      </div>
    </div>
  </div>

  <div class="error" *ngIf="ShowError">
    <validations [control]="controlName"></validations>
  </div>
</div>
